module.exports = __webpack_public_path__ + "img/arrow-left.b3904577.svg";